// extracted by mini-css-extract-plugin
export var searchHeader = "_1x-0";
export var searchHeaderDark = "_1x-1";